module.exports = __webpack_public_path__ + "img/user.67cfdbe3.png";